module.exports = __webpack_public_path__ + "img/left-arrow-icon.3714132c.svg";